export default __webpack_public_path__ + "static/media/BOLD_pressed.3d07565b.svg";